export const getSettingByCode = (
    settingCode: string,
    useCampaignSetting?: boolean
): Promise<string> => {
    const campaignSetting = useCampaignSetting ?? false;

    return new Promise<string>((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.addEventListener("load", (response) => resolve(xhr.response));
        xhr.addEventListener("error", (response) => reject(xhr.response));

        xhr.open(
            "GET",
            `/Shared/Services/SettingService.ashx?s=${settingCode}&cs=${campaignSetting}`
        );

        xhr.send();
    });
};
